module.exports = __webpack_public_path__ + "static/media/popup3-min.fa0285f8.png";